import styled from 'styled-components';
import shouldForwardProp from '@styled-system/should-forward-prop';
import { space, layout } from 'styled-system';
import { color, cursor } from '@magalu/stereo-ui-styles';
export const Svg = styled('svg').withConfig({
  shouldForwardProp
})`
  ${color}
  ${space}
  ${layout}
  ${cursor}
`;